import * as React from 'react';
import { MultiViewCalendar, MultiViewCalendarChangeEvent, DatePicker, TimePicker } from '@progress/kendo-react-dateinputs';
import * as moment from 'moment';
import { fetchApi, JsonResponse } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { IDName } from '../Accounts/Payments';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import { ButtonGroup, Button } from '@progress/kendo-react-buttons';

type Props = {
    Times: ScheduleTimes;
    CloseDialog: () => void;
    RefreshSchedule: () => void;
}

type State = {
    isLoading: boolean;
    instructors: Instructor[];
    instructorId: number;
    children: IDName[];
    childId: number;
    generateMode: number;
    daysOfWeek: number[];
    startTime: Date | null;
    endTime: Date | null;
    generationDates: Date[];
    generationStartDate: Date | null;
    generationEndDate: Date | null;
}

export type ScheduleTimes = {
    StartTime: Date;
    EndTime: Date;
}

type Instructor = {
    InstructorId: number;
    Name: string;
    Default: boolean;
}

export class ScheduleCreateModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: false,
            instructors: [],
            children: [],
            childId: 0,
            daysOfWeek: [1,2,3,4,5],
            generateMode: 1,
            startTime: null,
            endTime: null,
            generationDates: [],
            generationStartDate: null,
            generationEndDate: null,
            instructorId: 0,
        };

        this.save = this.save.bind(this);
        this.requestScheduleInfo = this.requestScheduleInfo.bind(this);
        this.onChangeCalendar = this.onChangeCalendar.bind(this);
    }

    public componentWillMount() {
        this.requestScheduleInfo();
    }

    public render() {
        return (<React.Fragment>
            <div className="k-overlay" style={{ zIndex: 10002, opacity: 0.5 }} />
            <div role="dialog" className="k-widget k-window k-dialog" style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 110px)', maxWidth: '90%', left: 0, right: 0, margin: '0 auto' }}>
                <div className="k-window-titlebar k-dialog-titlebar k-header">
                    <span className="k-window-title k-dialog-title">Create Schedule</span>
                    <button type="button" className="btn btn-sm btn-secondary dropdown-toggle ml-auto" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Presets
                    </button>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a className="dropdown-item" href="#" onClick={(e) => this.setPreset(e, [1,2,3,4,5], { hour: 8 }, { hour: 17 })}>Weekdays (8AM - 5PM)</a>
                        <a className="dropdown-item" href="#" onClick={(e) => this.setPreset(e, [1,2,3,4,5], { hour: 8 }, { hour: 12 })}>Weekdays (8AM - 12PM)</a>
                        <a className="dropdown-item" href="#" onClick={(e) => this.setPreset(e, [1,2,3,4,5], { hour: 12 }, { hour: 17 })}>Weekdays (12PM - 5PM)</a>
                    </div>
                    <div className="k-window-actions k-dialog-actions">
                        <a
                            role="button"
                            href="#"
                            className="k-button k-bare k-button-icon k-window-action k-dialog-action k-dialog-close"
                            title="Close"
                            aria-label="Close"
                            onClick={(e) => {
                            this.props.CloseDialog();
                            e.preventDefault();
                        }}>
                            <span className="k-icon k-i-close" />
                        </a>
                    </div>
                </div>
                <div data-role="dialog" className="k-content k-window-content k-dialog-content">
                    {this.state.isLoading && <LoadingPanel />}
                    <div className="k-form">
                        <TabStrip selected={this.state.generateMode} onSelect={(e) => this.setState({ generateMode: e.selected })}>
                            <TabStripTab title="Schedule Range">
                                <div className="form-group">
                                    <label htmlFor="daysOfWeek">Schedule Days</label>
                                    <ButtonGroup>
                                        <Button
                                            togglable={true}
                                            onClick={(e) => {
                                                this.setState({
                                                    daysOfWeek: this.state.daysOfWeek.indexOf(0) > -1 ?
                                                    this.state.daysOfWeek.filter(x => x !== 0) : [...this.state.daysOfWeek, 0]
                                                })
                                            }}
                                            selected={this.state.daysOfWeek.indexOf(0) > -1}
                                            primary={this.state.daysOfWeek.indexOf(0) > -1}
                                        >
                                            Sunday
                                        </Button>
                                        <Button
                                            togglable={true}
                                            onClick={(e) => {
                                                this.setState({
                                                    daysOfWeek: this.state.daysOfWeek.indexOf(1) > -1 ?
                                                    this.state.daysOfWeek.filter(x => x !== 1) : [...this.state.daysOfWeek, 1]
                                                })
                                            }}
                                            selected={this.state.daysOfWeek.indexOf(1) > -1}
                                            primary={this.state.daysOfWeek.indexOf(1) > -1}
                                        >
                                            Monday
                                        </Button>
                                        <Button
                                            togglable={true}
                                            onClick={(e) => {
                                                this.setState({
                                                    daysOfWeek: this.state.daysOfWeek.indexOf(2) > -1 ?
                                                    this.state.daysOfWeek.filter(x => x !== 2) : [...this.state.daysOfWeek, 2]
                                                })
                                            }}
                                            selected={this.state.daysOfWeek.indexOf(2) > -1}
                                            primary={this.state.daysOfWeek.indexOf(2) > -1}
                                        >
                                            Tuesday
                                        </Button>
                                        <Button
                                            togglable={true}
                                            onClick={(e) => {
                                                this.setState({
                                                    daysOfWeek: this.state.daysOfWeek.indexOf(3) > -1 ?
                                                    this.state.daysOfWeek.filter(x => x !== 3) : [...this.state.daysOfWeek, 3]
                                                })
                                            }}
                                            selected={this.state.daysOfWeek.indexOf(3) > -1}
                                            primary={this.state.daysOfWeek.indexOf(3) > -1}
                                        >
                                            Wednesday
                                        </Button>
                                        <Button
                                            togglable={true}
                                            onClick={(e) => {
                                                this.setState({
                                                    daysOfWeek: this.state.daysOfWeek.indexOf(4) > -1 ?
                                                    this.state.daysOfWeek.filter(x => x !== 4) : [...this.state.daysOfWeek, 4]
                                                })
                                            }}
                                            selected={this.state.daysOfWeek.indexOf(4) > -1}
                                            primary={this.state.daysOfWeek.indexOf(4) > -1}
                                        >
                                            Thursday
                                        </Button>
                                        <Button
                                            togglable={true}
                                            onClick={(e) => {
                                                this.setState({
                                                    daysOfWeek: this.state.daysOfWeek.indexOf(5) > -1 ?
                                                    this.state.daysOfWeek.filter(x => x !== 5) : [...this.state.daysOfWeek, 5]
                                                })
                                            }}
                                            selected={this.state.daysOfWeek.indexOf(5) > -1}
                                            primary={this.state.daysOfWeek.indexOf(5) > -1}
                                        >
                                            Friday
                                        </Button>
                                        <Button
                                            togglable={true}
                                            onClick={(e) => {
                                                this.setState({
                                                    daysOfWeek: this.state.daysOfWeek.indexOf(6) > -1 ?
                                                    this.state.daysOfWeek.filter(x => x !== 6) : [...this.state.daysOfWeek, 6]
                                                })
                                            }}
                                            selected={this.state.daysOfWeek.indexOf(6) > -1}
                                            primary={this.state.daysOfWeek.indexOf(6) > -1}
                                        >
                                            Saturday
                                        </Button>
                                    </ButtonGroup>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="generationStartDate">Schedule Start Date</label>
                                    <DatePicker
                                        format="MM/dd/yyyy"
                                        formatPlaceholder="formatPattern"
                                        value={this.state.generationStartDate}
                                        onChange={(e) => this.setState({ generationStartDate: e.value })}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="generationEndDate">Schedule End Date</label>
                                    <DatePicker
                                        format="MM/dd/yyyy"
                                        formatPlaceholder="formatPattern"
                                        value={this.state.generationEndDate}
                                        onChange={(e) => this.setState({ generationEndDate: e.value })}
                                    />
                                </div>
                            </TabStripTab>
                            <TabStripTab title="Select Days">
                                <MultiViewCalendar
                                    views={1}
                                    value={this.state.generationDates}
                                    onChange={this.onChangeCalendar}
                                />
                            </TabStripTab>
                        </TabStrip>
                        <div className="form-group">
                            <label htmlFor="startTime">Start Time</label>
                            <TimePicker
                                name="StartTime"
                                format="hh:mm a"
                                formatPlaceholder="formatPattern"
                                className="form-control"
                                value={this.state.startTime}
                                onChange={(e) => this.setState({ startTime: e.value})}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="endTime">End Time</label>
                            <TimePicker
                                name="EndTime"
                                format="hh:mm a"
                                formatPlaceholder="formatPattern"
                                className="form-control"
                                value={this.state.endTime}
                                onChange={(e) => this.setState({ endTime: e.value})}
                            />
                        </div>
                        <div className="form-group">
                            <label>Child</label>
                            <DropDownList
                                data={this.state.children}
                                textField="Name"
                                onChange={(e) => this.setState({ childId: e.target.value.ID }) }
                            />
                        </div>
                        <div className="form-group">
                            <label>Instructor</label>
                            <DropDownList
                                data={this.state.instructors}
                                textField="Name"
                                defaultItem={{ InstructorId: 0, Name: "None" }}
                                value={this.state.instructors.find(x => x.InstructorId == this.state.instructorId)}
                                onChange={(e) => this.setState({ instructorId: e.target.value.InstructorId }) }
                            />
                        </div>
                    </div>
                </div>
                <div className="k-button-group k-dialog-buttongroup k-dialog-button-layout-stretched" role="toolbar">
                    <button type="button" className="k-button" style={{ width: '50%' }} onClick={(e) => { this.props.CloseDialog(); e.preventDefault();}}>
                        Cancel
                    </button>
                    <button type="button" className="k-button k-primary" style={{ width: '50%' }} onClick={this.save}>
                        Save
                    </button>
                </div>
            </div>
        </React.Fragment>);
    }

    private setPreset(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, daysOfWeek: number[], start: { hour: number, minute?: number }, end: { hour: number, minute?: number }) {
        e.preventDefault();

        var startTime = new Date();
        startTime.setHours(start.hour);
        startTime.setMinutes(start.minute || 0);

        var endTime = new Date();
        endTime.setHours(end.hour);
        endTime.setMinutes(end.minute || 0);

        this.setState({ generateMode: 0, daysOfWeek, startTime, endTime });
    }

    private onChangeCalendar(e: MultiViewCalendarChangeEvent<MultiViewCalendar>) {
        if (e.value instanceof Date) {
            const date = e.value as Date;
            this.setState(prevState => ({ generationDates: prevState.generationDates.some(d => d.getTime() === date.getTime()) ?
                prevState.generationDates.filter(x => x.getTime() !== date.getTime()) : [...prevState.generationDates, date]}));
        } else if (Array.isArray(e.value)) {
            const dates = e.value as Date[];
            dates.forEach(date => {
                this.setState(prevState => ({ generationDates: prevState.generationDates.some(d => d.getTime() === date.getTime()) ?
                    prevState.generationDates.filter(x => x.getTime() !== date.getTime()) : [...prevState.generationDates, date]}));
            });
        }
    }

    private requestScheduleInfo() {
        fetchApi("api/Instructor/List", {}, "GET")
            .then((instructors: Instructor[]) => { this.setState({ instructors })});
        fetchApi("api/Children/List", {}, "GET")
            .then((response: IDName[]) => { this.setState({ children: response })});

        this.setState({
            daysOfWeek: [moment(this.props.Times.StartTime).day()],
            generationDates: [moment(this.props.Times.StartTime).startOf('day').toDate()],
            generationEndDate: this.props.Times.EndTime,
            generationStartDate: this.props.Times.StartTime,
            startTime: this.props.Times.StartTime,
            endTime: this.props.Times.EndTime
        });
    }

    private save() {
        if (this.state.startTime === null) {
            alert("Please enter a valid start time.");
            return;
        }
        if (this.state.endTime === null) {
            alert("Please enter a valid end time.");
            return;
        }
        if (this.state.childId == 0) {
            alert("A Child must be selected to create a schedule entry.");
            return;
        }
        if (this.state.generateMode === 0 && this.state.generationStartDate === null) {
            alert("Please enter an schedule start date.");
            return;
        }
        if (this.state.generateMode === 0 && this.state.generationEndDate === null) {
            alert("Please enter an scedule end date.");
            return;
        }
        if (this.state.generateMode === 1 && this.state.generationDates.length === 0) {
            alert("Please select atleast one date.");
            return;
        }
        if (this.state.generationStartDate > this.state.generationEndDate) {
            alert("Schedule end date cannot be before start date.");
            return;
        }

        const data = {
            DaysOfWeek: this.state.daysOfWeek,
            GenerationStartDate: this.state.generationStartDate,
            GenerationEndDate: this.state.generationEndDate,
            StartTime: moment(this.state.startTime).format("hh:mm a"),
            EndTime:  moment(this.state.endTime).format("hh:mm a"),
            InstructorId: this.state.instructorId
        } as any;

        if (this.state.generateMode == 1) {
            delete data.GenerationStartDate;
            delete data.GenerationEndDate;
            data.DaysOfWeek = [1,2,3,4,5];
            data.GenerationDates = this.state.generationDates;
        }

        this.setState({ isLoading: true })
        fetchApi(`api/ChildSchedule/Create/${this.state.childId}`, data, "POST")
            .then((response: JsonResponse) => {
                if (response.Success) {
                    this.props.RefreshSchedule();
                    this.props.CloseDialog();
                } else {
                    alert(response.ErrorMessage);
                }
            }).catch(() => {
                alert("Unknown Error Occurred!");
            }).finally(() => {
                this.setState({ isLoading: false });
            });
    }
}
